import { formatPesoAmount } from '../utils/money';
import React from 'react';
import { calculateStockAmounts } from '../utils/stockCost';
import { isStandardGranelPurchase } from '../utils/stockEntryGuidance';

const present = (value) => String(value ?? '').trim() !== '';
const number = (value) => Number(value ?? 0);
const money = (value) => `$${formatPesoAmount(value)}`;
const kilograms = (value) => value.toLocaleString('es-CL', { maximumFractionDigits: 3 });

export default function StockCostPerKgPreview({ draft = {}, isImportList = false }) {
  const granel = isStandardGranelPurchase({ ...draft, isImportList });
  const weight = number(draft.weightKg ?? draft.weight);
  const hasQuantity = present(draft.quantity);
  // The amounts and weight describe one purchased format, so its kg cost is
  // already available before quantity is entered. Granel describes one purchase.
  const quantity = granel || !hasQuantity ? 1 : number(draft.quantity);
  const hasAmount = present(draft.price) || present(draft.priceWithoutIva);
  const validAmounts = [draft.price, draft.priceWithoutIva]
    .every((value) => Number.isFinite(number(value)) && number(value) >= 0);
  const amounts = calculateStockAmounts({ ...draft, quantity });
  const totalKg = weight * quantity;
  const perKg = amounts.stockCostAmount / totalKg;
  const ready = hasAmount && validAmounts && weight > 0 && quantity > 0
    && Number.isFinite(totalKg) && Number.isFinite(perKg);

  return <div role="status" aria-live="polite" aria-atomic="true" aria-label="Vista previa del costo por kg"
    className="mt-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3">
    <p className="text-sm font-semibold text-slate-900">Costo por kg</p>
    <p className="mt-1 text-xl font-semibold text-blue-900">{ready ? `${money(perKg)} / kg` : '—'}</p>
    {ready ? <>
      <p className="mt-1 text-xs text-slate-600">{money(amounts.stockCostAmount)} ÷ {kilograms(totalKg)} kg{!granel && !hasQuantity ? ' por formato' : ''}</p>
      <p className="mt-1 text-xs text-slate-600">IVA incluido, antes de gastos.{draft.purchaseMode === 'other' ? ' Calculado con el peso estimado.' : ''}</p>
    </> : <p className="mt-1 text-xs text-slate-600">Ingresa los montos y un peso válido para ver el costo por kg.{hasQuantity && !granel && !(quantity > 0) ? ' La cantidad debe ser mayor a 0.' : ''}</p>}
  </div>;
}
